import { default as React } from 'react';
import {
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

// Same look as the internal Apps page header (MicroappCardGrid).
const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    width: 280,
  },
  searchIcon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
  },
  searchInput: {
    flex: 1,
    fontSize: '0.875rem',
  },
  clearButton: {
    padding: 4,
  },
}));

/**
 * IDP-1291: "Public Hosted Apps (N)" heading with one Filter box that searches
 * every displayed column (Name, Owner, Description). Used above both the card
 * and table layouts.
 */
export const PublicAppSearchBar = ({
  searchTerm,
  onSearchChange,
  count,
}: {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  count: number;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <Typography variant="h6">{`Public Hosted Apps (${count})`}</Typography>
      <Paper elevation={0} className={classes.searchBox}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          placeholder="Filter"
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
          inputProps={{
            'aria-label': 'Filter apps by name, owner or description',
          }}
        />
        {searchTerm && (
          <IconButton
            size="small"
            className={classes.clearButton}
            aria-label="Clear filter"
            onClick={() => onSearchChange('')}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </Paper>
    </div>
  );
};
